import { api } from "./api";

function base64UrlToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Notifiche non supportate da questo browser");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato");

  // Wait for service worker to be active (needed on first load)
  let registration = await navigator.serviceWorker.ready;
  if (!registration.active) {
    await new Promise((resolve) => {
      const check = () => {
        if (registration.active) resolve();
        else setTimeout(check, 100);
      };
      check();
    });
  }
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await api.get("/push/vapid-public-key");
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(data.publicKey),
    });
  }
  const customerEmail = localStorage.getItem("dorae_customer_email") || "";
  await api.post("/push/subscribe", { ...subscription.toJSON(), kind: customerEmail ? "customer" : "admin", customer_email: customerEmail });
  return subscription;
}
